const headerWrapper = document.querySelector('[data-name="header-wrapper-menu"]');

if (!headerWrapper.classList.contains("HomePageMenu")) {
  // Change navbar background style and navbar elements on scroll
  // window.addEventListener("scroll", () => {
  //   let y = 1 + (window.scrollY || window.pageYOffset) / 150;
  //   if (y > 1.45) {
  //     headerWrapper.style.backgroundColor = "rgba(255,255,255, 1)";
  //     headerWrapper.style.borderBottom = "1px solid #D9D9D9";
  //     headerWrapper.style.backdropFilter = "blur(10px)";
  //   } else {
  //     headerWrapper.style.backgroundColor = "transparent";
  //     headerWrapper.style.borderBottom = "1px solid transparent";
  //   }
  // });

  headerWrapper.style.backgroundColor = "rgba(255,255,255, 1)";
  headerWrapper.style.borderBottom = "1px solid #D9D9D9";
  headerWrapper.style.backdropFilter = "blur(10px)";

  // Mega menu change styles functions on hover
  function changeMegaMenuStyleOnHovered() {
    headerWrapper.style.backgroundColor = "rgba(255,255,255)";
    headerWrapper.style.borderBottom = "1px solid #D9D9D9";
  }

  // Clear navbar styles funcs on mouseleave
  // function clearMegaMenuStyle() {
  //   let y = 1 + (window.scrollY || window.pageYOffset) / 150;
  //   headerWrapper.style.backgroundColor = "rgba(255,255,255)";
  //   headerWrapper.style.borderBottom = "1px solid #D9D9D9";
  //   headerWrapper.style.backdropFilter = "blur(10px)";
    

  //   if (y < 1.2) {
  //     headerWrapper.style.backgroundColor = "transparent";
  //     headerWrapper.style.borderBottom = "1px solid transparent";
  //   }
  // }

  headerWrapper.addEventListener("mouseover", changeMegaMenuStyleOnHovered);
  headerWrapper.addEventListener("mouseleave", clearMegaMenuStyle);
}
